import { defineComponent as y, watchEffect as S, h as a } from "vue";
import { useDualCalendarProps as g, useDualCalendar as b } from "./ghl-ui.es1344.js";
import v from "./ghl-ui.es1343.js";
import { warnOnce as P } from "./ghl-ui.es853.js";
import m from "./ghl-ui.es182.js";
import f from "./ghl-ui.es373.js";
import { resolveSlot as l } from "./ghl-ui.es860.js";
import $ from "./ghl-ui.es1069.js";
import C from "./ghl-ui.es1067.js";
import D from "./ghl-ui.es1066.js";
import k from "./ghl-ui.es1068.js";
import _, { XButton as x } from "./ghl-ui.es253.js";
import O from "./ghl-ui.es1147.js";
const j = y({
  name: "DateTimeRangePanel",
  props: g,
  setup(o) {
    return process.env.NODE_ENV !== "production" && S(() => {
      var d;
      !((d = o.actions) === null || d === void 0) && d.includes("now") && P("date-picker", "The `now` action is not supported for n-date-picker of `datetimerange` type");
    }), b(o, "datetimerange");
  },
  render() {
    var o, d, p;
    const {
      mergedClsPrefix: e,
      mergedTheme: n,
      shortcuts: h,
      timePickerProps: c,
      onRender: u,
      $slots: s
    } = this;
    return u == null || u(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--datetimerange`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      class: `${e}-date-panel-header`
    }, a(m, {
      value: this.startDateDisplayString,
      theme: n.peers.Input,
      themeOverrides: n.peerOverrides.Input,
      size: this.timePickerSize,
      stateful: !1,
      class: `${e}-date-panel-date-input`,
      textDecoration: this.isStartValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleStartDateInputBlur,
      onUpdateValue: this.handleStartDateInput
    }), a(f, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timeFormat,
      size: this.timePickerSize
    }, Array.isArray(c) ? c[0] : c, {
      value: this.startTimeValue,
      to: !1,
      showIcon: !1,
      disabled: this.isSelecting,
      theme: n.peers.TimePicker,
      themeOverrides: n.peerOverrides.TimePicker,
      stateful: !1,
      isHourDisabled: this.isStartHourDisabled,
      isMinuteDisabled: this.isStartMinuteDisabled,
      isSecondDisabled: this.isStartSecondDisabled,
      onUpdateValue: this.handleStartTimePickerChange
    })), a(m, {
      value: this.endDateInput,
      theme: n.peers.Input,
      themeOverrides: n.peerOverrides.Input,
      stateful: !1,
      size: this.timePickerSize,
      class: `${e}-date-panel-date-input`,
      textDecoration: this.isEndValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleEndDateInputBlur,
      onUpdateValue: this.handleEndDateInput
    }), a(f, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timeFormat,
      size: this.timePickerSize
    }, Array.isArray(c) ? c[1] : c, {
      disabled: this.isSelecting,
      showIcon: !1,
      theme: n.peers.TimePicker,
      themeOverrides: n.peerOverrides.TimePicker,
      to: !1,
      stateful: !1,
      value: this.endTimeValue,
      isHourDisabled: this.isEndHourDisabled,
      isMinuteDisabled: this.isEndMinuteDisabled,
      isSecondDisabled: this.isEndSecondDisabled,
      onUpdateValue: this.handleEndTimePickerChange
    }))), a("div", {
      ref: "startDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--start`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, l(s["prev-year"], () => [a($, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, l(s["prev-month"], () => [a(C, null)])), a(v, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, l(s["next-month"], () => [a(D, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, l(s["next-year"], () => [a(k, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.startDateArray.map((t, i) => {
      const r = this.mergedIsDateDisabled(t.ts);
      return a("div", {
        "data-n-date": !0,
        key: i,
        class: [`${e}-date-panel-date`, {
          [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
          [`${e}-date-panel-date--current`]: t.isCurrentDate,
          [`${e}-date-panel-date--selected`]: t.selected,
          [`${e}-date-panel-date--covered`]: t.inSpan,
          [`${e}-date-panel-date--start`]: t.startOfSpan,
          [`${e}-date-panel-date--end`]: t.endOfSpan,
          [`${e}-date-panel-date--disabled`]: r
        }],
        onClick: r ? void 0 : () => {
          this.handleDateClick(t);
        },
        onMouseenter: r ? void 0 : () => {
          this.handleDateMouseEnter(t);
        }
      }, a("div", {
        class: `${e}-date-panel-date__trigger`
      }), t.dateObject.date, t.isCurrentDate ? a("div", {
        class: `${e}-date-panel-date__sup`
      }) : null);
    }))), a("div", {
      class: `${e}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--end`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, l(s["prev-year"], () => [a($, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, l(s["prev-month"], () => [a(C, null)])), a(v, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, l(s["next-month"], () => [a(D, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, l(s["next-year"], () => [a(k, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.endDateArray.map((t, i) => {
      const r = this.mergedIsDateDisabled(t.ts);
      return a("div", {
        "data-n-date": !0,
        key: i,
        class: [`${e}-date-panel-date`, {
          [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
          [`${e}-date-panel-date--current`]: t.isCurrentDate,
          [`${e}-date-panel-date--selected`]: t.selected,
          [`${e}-date-panel-date--covered`]: t.inSpan,
          [`${e}-date-panel-date--start`]: t.startOfSpan,
          [`${e}-date-panel-date--end`]: t.endOfSpan,
          [`${e}-date-panel-date--disabled`]: r
        }],
        onClick: r ? void 0 : () => {
          this.handleDateClick(t);
        },
        onMouseenter: r ? void 0 : () => {
          this.handleDateMouseEnter(t);
        }
      }, a("div", {
        class: `${e}-date-panel-date__trigger`
      }), t.dateObject.date, t.isCurrentDate ? a("div", {
        class: `${e}-date-panel-date__sup`
      }) : null);
    }))), this.datePickerSlots.footer ? a("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((o = this.actions) === null || o === void 0) && o.length || h ? a("div", {
      class: `${e}-date-panel-actions`
    }, a("div", {
      class: `${e}-date-panel-actions__prefix`
    }, h && Object.keys(h).map((t) => {
      const i = h[t];
      return Array.isArray(i) || typeof i == "function" ? a(x, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(i);
        },
        onClick: () => {
          this.handleRangeShortcutClick(i);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t
      }) : null;
    })), a("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((d = this.actions) === null || d === void 0) && d.includes("clear") ? a(_, {
      theme: n.peers.Button,
      themeOverrides: n.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((p = this.actions) === null || p === void 0) && p.includes("confirm") ? a(_, {
      theme: n.peers.Button,
      themeOverrides: n.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, a(O, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  j as default
};
